export default "__VITE_ASSET__BLARq5iU__"